// extracted by mini-css-extract-plugin
module.exports = {"nav":"vW","fixedNav":"vX","navRight":"vY","navLinkLogo":"vZ","navLink":"v0","navLinkActive":"v1","isRental":"v2"};